export type IncidentReviewAdminResponse = {
    available: IncidentItem[];
    selected: IncidentItem[];
}

export type IncidentItem = {
    statuscode: number;
    description: string;
}

export type IncidentReviewAdminRequest = {
    statuscodes: number[];
}

export type IncidentListingPayload={
    start_time:number|null;
    end_time:number|null;
    ordering?:string;
    disposition?:string;
    statuscodes?:string[];
    group_ids?:string;
    driver_id?:string;
    search?:string;
    page:number;
    page_size:number;
    csv_export?: number;
}
export type IncidentReviewConfigPayload={
    active_only?:boolean;
}

export type IncidentRecord = {
    recordid: number;
    deviceid: string;
    timestamp: number;
    statuscode: number;
    address: string;
    speedkph: number;
    speedlimitkph: number;
    odometerkm: number;
    sat_count: number;
    hdop: number;
    asset_name: string;
    incident_type: string;
    driver_name: string;
    disposition: string;
    disposition_comment: string;
    has_video: boolean;
};

// mirrors backend `Disposition` choices (incident_review/models.py)
export type TIncidentDisposition =
    | "pending"
    | "confirmed"
    | "inconclusive"
    | "false_positive"
    | "driver_not_at_fault";

// label + color per disposition value - single source of truth, shared by
// the listing page and the detail page's action bar/badge
export const INCIDENT_DISPOSITIONS: Record<TIncidentDisposition, { label: string; color: string }> = {
    pending: { label: "Pending", color: "#2563EB" },
    confirmed: { label: "Confirmed", color: "#009006" },
    inconclusive: { label: "Inconclusive", color: "#F57934" },
    false_positive: { label: "False Positive", color: "#E23131" },
    driver_not_at_fault: { label: "Driver Not At Fault", color: "#75485E" },
};

// dispositions that require a non-empty comment before they can be saved
export const INCIDENT_DISPOSITIONS_REQUIRING_COMMENT: TIncidentDisposition[] = [
    "false_positive",
    "driver_not_at_fault",
];

// GET /incident-review/api/v1/incidents/<recordid>/detail/
export type IncidentDetailResponse = {
    // header
    recordid: number;
    timestamp: number;
    incident_type: string;
    statuscode: number;

    // asset
    deviceid: string;
    asset_name: string;

    // driver
    driverid: string;
    driver_name: string;

    // GPS map - single pin, no route
    latitude: number;
    longitude: number;
    heading: number;
    altitude: number;
    address: string;

    // event metadata
    speedkph: number;
    speedlimitkph: number;
    gpsage: number;
    ignitionstate: number;

    // video - has_video only; actual video URL is fetched separately (on Play)
    has_video: boolean;

    // optional - not always present depending on account/event config
    video_ticket?: string;
    camera_id?: string;
    driving_time_in_sec?: number;

    // disposition
    disposition: TIncidentDisposition;
    disposition_comment: string;
    disposition_set_by: string;
    disposition_set_at: string | null;
};

// PUT /incident-review/api/v1/incidents/disposition/
export type IncidentDispositionPayload = {
    recordid: number;
    disposition: TIncidentDisposition;
    comment?: string;
};

export type IncidentDispositionResponse = {
    recordid: number;
    disposition: TIncidentDisposition;
    disposition_comment: string;
    disposition_set_by: string;
    disposition_set_at: string | null;
};

// GET /incident-review/api/v1/layout/
export type TIncidentWidgetId = "video" | "gps_map" | "weather" | "event_details";

export type IncidentWidgetLayoutItem = {
    id: TIncidentWidgetId;
    visible: boolean;
};

export type IncidentLayoutResponse = {
    widgets: IncidentWidgetLayoutItem[];
    is_default: boolean;
};
